{
  "top-salons-page": {
    "text": {
      "title": "Meilleurs salons",
      "hint": "Découvrez les salons de beauté les plus populaires dans vos villes préférées.",
      "country-label": "Pays",
      "country": {
        "DE": "Allemagne",
        "CH": "Suisse",
        "NL": "Pays-Bas"
      }
    },
    "meta": {
      "title": "Meilleurs salons | Beauty Booking",
      "description": "Découvrez les salons de beauté les plus populaires en Allemagne, en Suisse et aux Pays-Bas."
    }
  }
}
